<div class="text-start">
    <div>
        <h4 class="text-color-theme font-weight-bold ">
            <span>
                {{"AddPhoneReq" | translate}}
            </span>
            <mat-icon class="text-highlight-company-color" > phone</mat-icon>         
        </h4>
        <p class="text-muted-special font-medium">
            {{ "Add_Phone_Request_Description" | translate }}
        </p>
    </div>
    <form [formGroup]="phoneForm" >
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                <label class="required form-field-title text-color-theme ">{{ "phone" | translate }}</label>
                <input
                type="text"
                class="form-control"
                id="phoneNumber"
                name="phoneNumber"
                formControlName="phoneNumber"
                required 
                autocomplete="off"
                placeholder="{{ 'phone' | translate }}"
                />
            </div>
        </div>
        <button class="my-3 rounded-btn teal-btn" [disabled]="phoneForm.invalid" [ngClass]="{'disabled':phoneForm.invalid}" (click)="submit()"> {{'save' | translate}} </button>
    </form>
</div>

<ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>